<mat-form-field [formGroup]="group" class="input" appearance="outline">
  <mat-label>{{ config.label }}</mat-label>
  <input #input type="number" class="numeric" min="{{config.min}}" matInput [formControlName]="config.name" placeholder="{{config.placeholder}}"
  (focus)="keyboardService.onInputFocus(keyboardChange, $event)"
  (ngModelChange)="keyboardService.onInputChange(group.getRawValue(), input)"
  />
  <!-- <mat-error *ngIf="group.get(config.name)?.touched && group.get(config.name)?.hasError('required')">
    <span>Campo Obrigatório</span>
  </mat-error> -->
</mat-form-field>
